import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EmployeeDto } from 'src/app/models/EmployeeDto';
import { DocumentModel } from 'src/app/models/requests/DocumentUploadDto';
import { DocumentsService } from 'src/app/services/documents.service';
import { EmployeesService } from 'src/app/services/employees.service';
import { ExcelexportService } from 'src/app/services/excelexport.service';
import { NotificationService } from 'src/app/services/notification.service';
import { TokenService } from 'src/app/services/token.service';
import { NzContextMenuService, NzDropdownMenuComponent } from 'ng-zorro-antd/dropdown';
import { MenuItem } from 'primeng/api';
import { LoginResponseData } from 'src/app/models/responses/login-response-data';
import { NotificationType } from 'src/app/models/notification.message';
import { LocationDto } from 'src/app/models/LocationDto';
import { LocationsService } from 'src/app/services/locations.service';
@Component({
  selector: 'app-contractsemployees',
  templateUrl: './contractsemployees.component.html',
  styleUrls: ['./contractsemployees.component.css']
})
export class ContractsemployeesComponent implements OnInit {



  radioValue = 'A';

  biometricUpdateTitle = 'Biometric Info Update';
  items: MenuItem[] = [];
  terminationComment = ''
  terminationDate: Date = new Date();
  isTerminationVisible: boolean = false;
  bioOfficerName: string = '';
  datecaptured: Date = new Date();
  biometricenddate: Date = new Date();
  biometricstartdate: Date = new Date();
  Employees: EmployeeDto[] = [];
  ViewEmployeeVisible: boolean = false;
  UpdateEmployee: any;
  public searchText: string = '';
  loading: boolean = true;
  userRole: string = ''
  edit: boolean = false
  updateButtonVisible: boolean = false
  safetyOption: boolean = false;
  biometricOption: boolean = false;

  safetyStatus: boolean = false;
  biometricStatus: boolean = false;
  safetyOfficer: string = ''
  safetyInductionDate: Date = new Date();
  size: number = 0;
  Documents: DocumentModel[] = [];
  isChangeOkLoading = false;
  isSafetyVisible: boolean = false;
  isBiometricModalVisible: boolean = false;
  safetyTitle: string = "Safety Info Update";
  terminateTitle: string = 'Terminate Employee : ';
  CanviewDocuments: boolean = false;
  canTerminateEmployees: boolean = false;
  CanAddDocuments: boolean = false;
  activeStatus: boolean = false;

  selectedLocationId: number = 0;
  Locations: LocationDto[] = [];
  isLocationModalVisible: boolean = false;
  locationUpdateTitle: string = '';
  currentUser: any;
  department: any;
  isHrbp: boolean = false;


  constructor(private router: Router, private datepipe: DatePipe, private nzContextMenuService: NzContextMenuService, private documentService: DocumentsService, private employeeService: EmployeesService, private tokenService: TokenService,
    private notification: NotificationService, private locationService: LocationsService, ) {
    this.Employees = this.router.getCurrentNavigation()?.extras?.state?.data;
    this.size = this.Employees.length;

    this.loading = false;

  }

  ngOnInit(): void {
    this.getInfo();


  }
  getInfo(){
    this.currentUser = this.tokenService.getInfo();
    this.department = this.currentUser.profile.departmentName;
    this.isHrbp = this.department == 'ORGANIZATION & HUMAN RESOURCES'; 
  }

  openSideView(data: any) {
    this.UpdateEmployee = data;
    this.open(this.UpdateEmployee);
  }
  openBiometricCapture() {
    this.isBiometricModalVisible = true;
    this.biometricUpdateTitle = "Biometric Info Update for : " + this.UpdateEmployee.firstName;
    this.bioOfficerName = this.UpdateEmployee.bioOfficerName;


  }

  openTerminate(data: any) {

    this.UpdateEmployee = data;
    this.isTerminationVisible = true;
    this.terminateTitle = "Manage End date for for: " + this.UpdateEmployee.firstName;
    this.terminationDate = this.UpdateEmployee.endDate;
    var status = this.UpdateEmployee.isActive;
    this.activeStatus = this.UpdateEmployee.isActive;
    if (status === true) { this.radioValue = "A" }
    else { this.radioValue = "B" }

    
  }

  openSafetyCapture() {
    
    this.isSafetyVisible = true;
    this.safetyOfficer = this.UpdateEmployee.safetyInductionDoneBy;
    //  this.safetyInductionDate = this.UpdateEmployee.safetyInductiondate;
    this.safetyStatus = this.UpdateEmployee.isSafetyInductionDone;

    var date: Date = this.UpdateEmployee.safetyInductiondate;
    var datestring = this.datepipe.transform(date, 'MM/dd/yyyy');
    let date1: Date = new Date(datestring!);
    this.safetyInductionDate = date1;

    this.safetyTitle = 'Update Safety Info for : ' + this.UpdateEmployee.firstName;
  }

  cancel() {

  }

  buildContextMenus() {
    this.items = [
      { label: 'View', icon: 'pi pi-fw pi-search', command: () => this.open(this.UpdateEmployee) },
      //    {label: 'Delete', icon: 'pi pi-fw pi-times', command: () => this.deleteProduct(this.selectedProduct)}
    ];
  }
  async loadRecords() {

    let resEmployees = await this.employeeService.getEmployeesForRequester().toPromise();
    this.Employees = <EmployeeDto[]>resEmployees.responseData;
    this.size = this.Employees.length;

  }



  getStatusColor(status: boolean): string {
    switch (status) {
      case true:
        return 'badge badge-success';
      case false:
        return 'badge badge-danger';

      default:
        return 'badge badge-info';
    }

  }




  handleCancel(): void {

    this.isBiometricModalVisible = false;
  }
  handleCancel2(): void {

    this.isSafetyVisible = false;
  }
  handleCancel3(): void {

    this.isTerminationVisible = false;
  }
  async open(data: EmployeeDto) {

    
    this.UpdateEmployee = data;
    this.safetyStatus = data.isSafetyInductionDone;
    this.biometricStatus = data.isBiometricCaptured;
    this.ViewEmployeeVisible = true;
    this.bioOfficerName = '';

    let docs = await this.documentService.getDocumentsByEmployee(data.id).toPromise();
    this.Documents = <DocumentModel[]>docs.responseData;

  }

  close(): void {
    this.ViewEmployeeVisible = false;
    this.edit = false
    this.getUserData();
  }

  getUserData(): void {

    try {

      


      const userData: LoginResponseData = this.tokenService.getInfo();
      this.userRole = userData.profile.roleName;
      var UserPermission = userData.permission;

      const BiometricPerm = UserPermission.find((obj) => {
        return obj.permissionName === "Biometric";
      });

      if (BiometricPerm) {
        if (BiometricPerm.canAdd) {
          this.biometricOption = true;
          //   this.updateButtonVisible = true

        }

      }

      /*    if (this.userRole === "Biometric officer") {
            this.biometricOption = true;
            this.updateButtonVisible = true
          }
    */
      const SafetyPerm = UserPermission.find((obj) => {
        return obj.permissionName === "Safety";
      });

      if (SafetyPerm) {
        if (SafetyPerm.canAdd) {
          this.safetyOption = true
          this.updateButtonVisible = true
          this.safetyOfficer = userData.fullNamme

        }

      }

      const EmployeesPerm = UserPermission.find((obj) => {
        return obj.permissionName === "Employees";
      });
      if (EmployeesPerm) {
        if (EmployeesPerm.canTerminate) {
          this.canTerminateEmployees = true
        }
      }

      
      const DocumentsPerm = UserPermission.find((obj) => {
        return obj.permissionName === "Documents";
      });
      if (DocumentsPerm) {
        if (DocumentsPerm.canRead) {
          this.CanviewDocuments = true;
        }
        if (DocumentsPerm.canAdd) {
          this.CanAddDocuments = true;
        }
      }
    }
    catch (e: unknown) { }
  }

  updateBiometrics() {
    const data =
    {

      id: this.UpdateEmployee.id,
      captured: this.biometricStatus,
      datecaptured: this.datecaptured,
      bioOfficerName: this.bioOfficerName,
      biometricEndDate: this.biometricenddate,
      biometricStartDate: this.biometricstartdate
    }
    if (data.bioOfficerName.length == 0) {
      this.notification.sendMessage({
        message: 'Biometric officer is required',
        type: NotificationType.error
      });
      return;
    }
    this.employeeService.updateBiometrics(data).subscribe({
      next: (data => {
        debugger
        if (data.responseCode == "00") {
          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.success
          });
          this.loadRecords()
          this.close()
        }
        else {

          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.error
          });

        }

      }),
      error: ((error: any) => {
        console.log(error.error);
        


        this.notification.sendMessage({
          message: error.error.message,
          type: NotificationType.error
        });
      })

    });
  }

  onChangeInductionDate(result: Date): void {

    if (result) {
      this.safetyInductionDate = result;

    }

  }

  onChangeTerminationDate(result: Date): void {
    this.terminationDate = result;
  }

  updateSafety() {
    const data =
    {
      id: this.UpdateEmployee.id,
      safetyDone: this.safetyStatus,
      safetyInductionDate: this.safetyInductionDate,
      safetyOfficerName: this.safetyOfficer
    }

    this.employeeService.updateSafety(data).subscribe({
      next: (data => {
        debugger
        if (data.responseCode == "00") {
          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.success
          });
          this.loadRecords()
          this.isSafetyVisible = false;
          this.close()
        }
        else {

          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.error
          });

        }

      }),
      error: ((error: any) => {
        console.log(error.error);
        


        this.notification.sendMessage({
          message: error.error.message,
          type: NotificationType.error
        });
      })

    });
  }

  beginEdit() { this.edit = true, this.updateButtonVisible = false }

  openDocuments() {
    
    var id = this.UpdateEmployee.id;
    this.router.navigate(['/employeedocuments'], { queryParams: { id } });

  }

  terminateEmployeeUpdate() {

    let stataus = this.radioValue === "A" ? true : false;
    const data =
    {
      empId: this.UpdateEmployee.id,
      message: this.terminationComment,
      enddate: this.terminationDate,
      status: stataus

    }

    this.employeeService.TerminateEmployee(data).subscribe({
      next: (data => {
        debugger
        if (data.responseCode == "00") {
          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.success
          });
          this.loadRecords()
          this.isTerminationVisible = false;
          this.close()
        }
        else {

          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.error
          });

        }

      }),
      error: ((error: any) => {
        console.log(error.error);
        


        this.notification.sendMessage({
          message: error.error.message,
          type: NotificationType.error
        });
      })

    });
  }

  downloadExcel() {
    const exportData: Partial<object>[] = this.Employees.map(
      x => ({
        Reference: x.contractReference,
        Firstname: x.firstName,
        Lastname: x.lastName,
        Gender: x.gender,
        Age: x.age,
        Phonenumber: x.phoneNumber,
        Email: x.email,
        Department: x.departmentName,
        Location: x.locationName,
        CostCenter: x.costCenterName,
        Contractor: x.contractorName,
        Position: x.position,
        Qualification: x.qualification,
        Address: x.address,
        NextofKin: x.nextOfKin,
        NextOfKinAddress: x.nextOfKinAddress,
        NextOfKinPhone: x.nextOfKinPhone,
        Status: x.isActive ? 'Active' : 'Inactive',
      })
    )
    ExcelexportService.exportArrayToExcel(exportData, 'Employee Export')
  }

  async openChangeLocationModal() {
    this.locationUpdateTitle = "Move " + this.UpdateEmployee.firstName + " from " + this.UpdateEmployee.currentLocationName + " to:";
    this.isLocationModalVisible = true;

    if (this.Locations === undefined || this.Locations.length == 0) {
      let resLocations = await this.locationService.getLocations().toPromise();
      this.Locations = <LocationDto[]>resLocations.responseData;
    }
  }

  handleLocationUpdateCancel() {
    this.isLocationModalVisible = false;
  }

  changeLocation() {

    const requestData = { id: this.UpdateEmployee.id, locationId: this.selectedLocationId };

    if (requestData.id == 0) {
      this.notification.sendMessage({
        message: 'Location is required',
        type: NotificationType.error
      });
      return;
    }

    this.employeeService.ChangeLocation(requestData).subscribe({
      next: (data => {
        debugger
        if (data.responseCode == "00") {
          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.success
          });

          this.handleLocationUpdateCancel();

          var recordIndex = this.Employees.findIndex((employee => employee.id == requestData.id));
          let currentLocationName = this.Locations.find((location => location.id == data.responseData.currentLocationId))?.name
          this.Employees[recordIndex].currentLocationName = currentLocationName? currentLocationName : this.UpdateEmployee.locationName;

          this.Employees = [...this.Employees];

          this.close();
        }
        else {
          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.error
          });
        }

      }),
      error: ((error: any) => {
        this.notification.sendMessage({
          message: error.error.message,
          type: NotificationType.error
        });
      })
    });
  }
}
